import * as React from 'react'
import { useMemo } from 'react'
import {
  BulkActionCircularProgress,
  BulkActionErrorDescription,
  BulkActionErrorSummary,
} from '../../BulkActionErrors'
import { bulkActionErrors } from '../../constants'
import { ErrorSummary } from './typings'

export const RowErrors: React.FC<{
  loading: boolean
  errorSummary: ErrorSummary
}> = (props) => {
  const {
    loading,
    errorSummary: { count, hasAlreadyClosed, hasUnableToClose },
  } = props

  const description = useMemo(() => {
    const noun = count === 1 ? 'record' : 'records'
    return `${count} ${noun} found that cannot be updated.`
  }, [count])

  const display = useMemo(
    () => !loading && count > 0 && (hasAlreadyClosed || hasUnableToClose),
    [count, hasAlreadyClosed, hasUnableToClose, loading],
  )

  return (
    <>
      <BulkActionCircularProgress loading={loading} />
      {display ? (
        <>
          <BulkActionErrorSummary description={description} />
          {hasUnableToClose && (
            <BulkActionErrorDescription
              detail={bulkActionErrors.updateStatus.requirements}
            />
          )}
          {hasAlreadyClosed && (
            <BulkActionErrorDescription
              detail={bulkActionErrors.updateStatus.closed}
            />
          )}
        </>
      ) : null}
    </>
  )
}
RowErrors.displayName = 'RowErrors'
